export function routes($stateProvider) {
    $stateProvider
        .state('app.obler.viaturas', {
        url: '/viaturas',
        abstract: true
    })
        .state('app.obler.viaturas.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Viaturas',
        role: ['oblerVerViaturas'],
        template: require('./list/view.html'),
        controller: 'OblViaturaListController',
        controllerAs: 'vm',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.obler.viaturas.details', {
        url: '/{id}',
        title: 'Detalhes da Viatura',
        role: ['oblerVerViaturas'],
        template: require('./details/view.html'),
        controller: 'OblViaturaDetailsController',
        controllerAs: 'vm',
    });
}
routes.$inject = ['$stateProvider'];
